import React from 'react'
import { Typography, Grid } from '@mui/material';
import { texts } from "../../../general/texts";
import Divider from '@mui/material/Divider';
import colors from '../../../colors'

const SingleLatestTransaction = (props) => 
{
    return(
        <Grid container item md={12} xs={12} flexDirection='row' spacing={1.5}>
            <Grid container flexDirection={'column'} justifyContent={'center'} item xs={3}  md={2}>
                <img width={'45vw'} src={props.transactionData.serviceLogo}/>
            </Grid>
            <Grid container item md={10} xs={9} spacing={1} sx={{'@media (max-width: 1220px)' : {pl:'20%'}}} >
                <Grid container item justifyContent={'flex-start'} md={12}>
                    <Typography sx={{fontFamily:'GerberaBold', color:colors.darkBlue}}>{props.transactionData.serviceName}</Typography>
                </Grid>
                <Grid container item md={12} xs={12}>
       
                    <Grid container item  md={8} xs={8} justifyContent={'flex-start'}>
                        <Typography sx={{color:colors.gray, fontFamily:'GerberaLight', fontSize: "0.8rem"}} >
                        {texts["date"]}: {props.transactionData.date !== undefined ? props.transactionData.date : '-'}
                        </Typography>
                    </Grid>
                    <Grid container item md={8} xs={8} justifyContent={'flex-start'}>
                        <Typography sx={{color:colors.gray, fontFamily:'GerberaLight', fontSize: "0.8rem"}} >
                        {texts["transId"]}: {props.transactionData.transId !== undefined ? props.transactionData.transId : '-'}
                        </Typography>
                    </Grid>
                    <Grid container item md={8} xs={8} justifyContent={'flex-start'}>
                        <Typography sx={{color:colors.gray, fontFamily:'GerberaLight', fontSize: "0.8rem"}} >
                        {texts["serial"]}: {props.transactionData.serial !== undefined ? props.transactionData.serial : '-'}
                        </Typography>
                    </Grid>
                    <Grid container item justifyContent={'flex-end'} md={12} xs={12} >
                        {
                            props.transactionData.type === 0 
                            ? <Typography sx={{color:colors.green, fontFamily:'GerberaLight'}}>{'+ ' + props.transactionData.value+ ' ' + texts["currency"]}</Typography>
                            : <Typography sx={{color:colors.red, fontFamily:'GerberaLight'}}>{'- ' + props.transactionData.value + ' ' + texts["currency"]}</Typography>
                        } 
                    </Grid>
                </Grid>
            </Grid>
            <Grid item md={12} xs={12} pb={'4%'}>
                <Divider sx={{ borderWidth: 0.5 }}/>
            </Grid>          
        </Grid>

    )
}
export default SingleLatestTransaction